var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTeacherTreeViewArrow = function SvgTeacherTreeViewArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.293 3.96a1 1 0 0 0 1.414 0L7.53 1.136a.665.665 0 0 0-.94-.941L4 2.78 1.41.196a.665.665 0 0 0-.94.94L3.293 3.96Z",
    fill: "#6C6C73"
  })));
};
export default SvgTeacherTreeViewArrow;